<ion-content class="container">
  <div class="tabs-container">

    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)">
              <mat-tab label="Dashboard" >
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Dashboard</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Employee Admin"
                *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      person
                    </span>My Reimbursement</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Manager"
                *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' ||loggedInUserRole == 'Employee' ||approveMatrix=='EMPLOYEE_TO_FINANCE')">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      ads_click
                    </span>Team Reimbursement </span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Finance"
                *ngIf=" (isFinanceLoginUser || loggedInUserRole == 'HR Admin')  ">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      ads_click
                    </span> Reimbursement Approve</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Reports">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      description
                    </span>Reports</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>
        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10"
          *ngIf="!router.url.includes('Setup') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
          <div class="center-content float-right">
            <div>
              <span class="cp fs-14 link font_regular center-content mr-20" (click)="onClickLogs('Logs')">
                <img src="././assets/icon/logsIcon.svg"><u>Logs</u></span>
            </div>
            <div>
              <button type="button" class="add_btn fs-14 float-right center-content mr-5"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup</button>
            </div>
          </div>
        </ion-col>
      </ion-row>

    </div>



    <!---Setup Popup --->
    <div class="modal fade" [style.display]="showSetupPopup ? 'block' : 'none'" >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
            <img (click)="onClickBreadcrumExpence()" src="././assets/icon/backArrow.svg" class="cp">
            <label class="font_semibold fs-18 ml-10 mt-5 black_color">
              <span class="cp" (click)="onClickBreadcrumExpence()">Expense</span> /
              <span [style.color]="buttonColorName">Setup</span>
            </label>
          </div>
          <div class="modal-body p-20">
            <div class="mt-10">
              <div class="cardBox card" style="background-color: white; padding: 10px;">
                <ion-row>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Fiscal Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="inputBoxDisabled">
                      {{ sharedService.transform(loggedInCompanyFiscalyear) }}
                    </div>
                  </ion-col>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                        (selectionChange)="getYearSetupForReimbursement()">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{sharedService.transformYearToFyFormat(item.year)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>

                </ion-row>
                <ion-row class="d-flex">
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Approve Matrix?<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field appearance="outline" class="w-100 mat-height40" style=" margin-top: 10px;">
                      <mat-label class="centered-label">Select Approve Matrix</mat-label>
                      <mat-select [(ngModel)]="approveMatrix" name="approvalMatrixSelect"
                        [disabled]="isLimitTypeLocked">
                        <mat-option value="EMPLOYEE_TO_MANAGER_TO_FINANCE">
                          Employee To Manager To Finance
                        </mat-option>
                        <mat-option value="EMPLOYEE_TO_FINANCE">
                          Employee To Finance
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>


                  <!-- Finance Admin Section -->

                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Finance Admin<span class="red-cl">&nbsp;*</span>

                    </div>

                    <mat-form-field appearance="outline" class="w-100 mat-height40" style="margin-top: 10px">
                      <mat-label class="centered-label">Select Finance Admin</mat-label>
                      <mat-select [(ngModel)]="selectedEmployee" name="reimbursementSelect" multiple>
                        <mat-option *ngFor="let item of getAllFinanceUserDD" [value]="item.id"
                          (click)="confirmSelection(item, $event)"
                          [disabled]="allreadySellectedFinanceAdmin.includes(item.id) && reimbursementTable.length>0 && loggedInUserRole != 'Super Admin'">
                          {{ item.firstName }} {{ item.lastName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </ion-row>

                
                <ion-row>
                  <ion-col size="12" class="mt-10">
                    <div class="font_semibold fs-16 mb-5">
                      Reimbursement Type <span class="red-cl">&nbsp;*</span>
                    </div>
                  </ion-col>
                  <ion-col size="12" *ngIf="!isReimbursementType">
                    <div class="font_semibold addnewbtn fs-14 cp" (click)="toggleInputs()">
                      + Add New
                    </div>
                  </ion-col>


                  <ion-row *ngIf="showInputs" class="mb-10">
                    <ion-col size="12">
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput [(ngModel)]="reimbursementAdd" 
                                        type="text"
                                        placeholder="Reimbursement Type "
                                        class="font_regular fs-12"
                                        min="1"
                                        [attr.disabled]="restrictToEditSetup ? true : null"
                                        (keypress)="preventNegative($event)"
                                        (input)="validateInput($event)"  />
                     
                      </mat-form-field>
                      
                    </ion-col>

                  </ion-row>
                  <ion-col size="12" *ngIf="showInputs">
                    <ion-row>
                      <ion-col size="auto">
                        <div class="font_semibold addnewbtn fs-14 cp" [ngClass]="{ 'disabled': !reimbursementAdd }"
                          (click)="!reimbursementAdd || saveData()">
                          Save
                        </div>

                      </ion-col>
                      <ion-col size="auto">
                        <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                          Cancel
                        </div>
                      </ion-col>
                    </ion-row>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="mt-10">
                    <div class="table-container">  
                      <table class="custom-table rounded-header">
                        <thead>
                          <tr>

                            <th class="font_semibold fs-14">Reimbursement Type</th>

                            <th class="font_semibold fs-14 text-center">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngIf="reimbursementTable.length === 0">
                            <td colspan="3" class="text-center">No Records</td>
                          </tr>
                          <tr *ngFor="let data of reimbursementTable; let i = index">
                            <td>

                              <span *ngIf="editableIndex !== i || !EditData">{{ data.reimbursementType }}</span>
                              <mat-form-field *ngIf="editableIndex === i && EditData"
                                class="w-100 mat-height40 mat-input-style">
                                  <input  type="hidden" [(ngModel)]="data.reimbursementId"  />
                                <input matInput type="text" [(ngModel)]="data.reimbursementType"
                                  placeholder="Edit Reimbursement Type"
                                  (ngModelChange)="updateSpecificreimbursmentType(data)" class="font_regular" />
                              </mat-form-field>
                            </td>

                            <td>

                              <span class="material-icons fs-20 red cp"
                                (click)="deleteReImbursement(data.reimbursementType,i);">delete</span>

                              <span class="material-icons fs-20 blue cp" *ngIf="(editableIndex !== i || !EditData)"
                                (click)="editReImbursement(data, i)" style="margin-left: 5px;">edit</span>
                              <!-- <mat-icon>edit</mat-icon> -->
                              <!-- Close Icon -->
                              <span *ngIf="editableIndex === i && EditData" class="material-icons close p-10 cp fs-20"
                                (click)="closeEditing()">
                                close
                              </span>

                              <!-- Save Icon -->
                              <!-- <span *ngIf="editableIndex === i && EditData" class="material-icons link p-10 cp fs-20"
                                (click)="updateReimbursement()"> -->
                              <span *ngIf="editableIndex === i && EditData" class="material-icons link p-10 cp fs-20"
                                (click)="updateReimbursementType(data.reimbursementId)">
                                check
                              </span>
                            </td>

                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
                <ion-row>

              
                  <ion-col size="12" class="mt-10"  *ngIf="reimbursementTable.length > 0">
                    <div class="font_semibold fs-16 mb-5">
                      Do you want limit?<span class="red-cl">&nbsp;*</span>
                    </div>
                  
                    <mat-radio-group
                      [(ngModel)]="wantLimit"
                      aria-label="Select an option"
                      class="fs-14 font_semibold"
                      [disabled]="isLimitTypeLocked"
                      (change)="onSelectionChangeForWantLimit($event.value)">
                      <mat-radio-button value="yes">
                        Yes
                      </mat-radio-button>
                      <mat-radio-button value="no" class="pl-10">
                        No
                      </mat-radio-button>
                    </mat-radio-group>
                  </ion-col>
                  


                  <ion-col size="12" class="mt-10" *ngIf="wantLimit=='yes'">
                    <div class="font_semibold fs-16 mb-5">
                      How do you want to at limit?<span class="red-cl">&nbsp;*</span>
                    </div>

                    <mat-form-field appearance="outline" class="w-50 mat-height40" style="width:30% ;margin-top: 10px;">
                      <mat-label>Select Limit Type</mat-label>
                      <mat-select [(ngModel)]="limitType" aria-label="Select an option" [disabled]="isLimitTypeLocked"
                        (selectionChange)="onSelectionChangeLimit($event)">
                        <mat-option value="Band">Band</mat-option>
                        <mat-option value="Location">Location</mat-option>
                        <mat-option value="Neither">Neither</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div *ngIf="isLimitTypeLocked" class="info-text">
                      <small>The limit type is locked and cannot be changed within 1 year of the initial
                        selection.</small>
                    </div>
                  </ion-col>



                </ion-row>
                <div style="width: 30%;" >
                  <ion-col size="4" class="mt-10"*ngIf="wantLimit!=='no' && wantLimit!==''">
                    <div class="font_semibold fs-16 mb-5 ">
                      Select Reimbursement<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field appearance="outline" class="w-100 mat-height40" >
                      <!--  [ngClass]="isReimbursementInvalid(item) ? 'red-background' : 'green-background'" -->
                      <mat-label class="centered-label">Select Reimbursement</mat-label>
                      <mat-select class="centered-label" [(ngModel)]="selectedReimbursement" name="reimbursementSelect"
                        (selectionChange)="onSelectionChange($event);onReimbursementIdChange($event.value)">
                        <mat-option *ngFor="let item of reimbursementTable" [value]="item.reimbursementId">

                          {{ item.reimbursementType }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </div>


              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="card">  
        <div class="card-body">
          <div class="p-10">

            <div class="setUptable-container table-container">
              <table class="hover mb-5 reimbursmenttable custom-table rounded-header"
                *ngIf="selectedReimbursement!=null && wantLimit!=='no' && wantLimit!=='' && limitType!=''">

                <thead class="bg-gray">
                  <tr>
                    <th class="fs-14 font_bold cl-black" *ngIf="limitType=='Band'">Band</th>
                    <th class="fs-14 font_bold cl-black" *ngIf="limitType=='Location'">Location</th>
                    <th class="fs-14 font_bold cl-black"
                      *ngIf="limitType=='Band' ||limitType=='Location'||limitType=='Neither'">Limit</th>
                    <!-- <th class="fs-14 font_bold cl-black">Total weightage</th> -->
                    <th class="fs-14 font_bold cl-black"></th>
                  </tr>
                </thead>

                <tbody class="bg-white">

                  <tr *ngFor="let item of bandListData ; let rowId = index">

                    <td class="fs-14 font_regular" *ngIf="limitType=='Band'">

                      <span>{{item.band}}</span>
                    </td>

                    <td class="fs-14 font_regular" *ngIf="limitType=='Location'">
                      <span>{{item.location}}</span>
                    </td>
                    <td class="fs-14 font_regular"> 
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                      
                        <input [(ngModel)]="item.reimbursementId" type="hidden"
                          *ngIf="!reimbursementAddId && !reimbursementBandId" placeholder="Set Limit"
                          class="font_regular">
                        <input [(ngModel)]="item.limit" type="number" 
                              (ngModelChange)="IndividualTotalWeightage(item)"
                              (keydown)="preventNegative($event)" 
                              [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled" matInput
                          placeholder="Set Limit" class="font_regular">
                      </mat-form-field>

                    </td>

                    <td>
                      <div class="d-flex">
                        <img (click)="onClickIndividualScoreEdit(rowId)" *ngIf="editedIndividualScoreId !== rowId"
                          class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">
                        <span (click)="getScoreToFinalConverterIndividual()"
                          *ngIf="editedIndividualScoreId === rowId && onCheckIconView"
                          class="material-icons close p-10 cp fs-20">close</span>
                        <!-- Single condition for reimbursementAddId check -->
                        <span *ngIf="editedIndividualScoreId === rowId && onCheckIconView "
                          (click)="handleReimbursementClick(item.reimbursementId,rowId)"
                          class="material-icons link p-10 cp fs-20">
                          check
                        </span>

                        <!-- <span *ngIf="editedIndividualScoreId === rowId && onCheckIconView && reimbursementAddId != null " (click)="reimbursementAddId!=null?updatesaveReimbursement():''" class="material-icons link p-10 cp fs-20">check</span>
                  <span *ngIf="editedIndividualScoreId === rowId && onCheckIconView && reimbursementAddId == null" (click)="item.reimbursementId!=null?updateReimbursement():saveReimbursement()" class="material-icons link p-10 cp fs-20">check</span> -->
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>






    <!-------------------------------------------------------Employee Login ------------------------------------------------>

    <div class="card  employeeTab">
      <div class="card-body">
        
        <div>

          <div class="p-10" *ngIf="selectedTypeTabName=='Employee Admin'">
             <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
          <mat-form-field class="mat-height40 mat-input-style" style="margin-left: 20px;">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchTaskString"
              (input)="onSearchTask(searchTaskString)">
          </mat-form-field>
        </ion-col>
            <button type="button" class="add_btn fs-14 mr-15"
              style="display: flex;float: right; margin-bottom:10px; align-items: center"
              [style.background-color]="buttonColorName" (click)="addKPISPopup(null)">
              + New Reimbursement</button>
            <div class="table-container"> 

              <table class="custom-table rounded-header">

                <thead>
                  <tr>
                    <!-- <th class="mat-checkbox-style">
                  <mat-checkbox
                    [(ngModel)]="selectAllTaskCheckbox"
                    [checked]="selectAllTaskCheckbox"
                    (change)="selectALLTaskRecords($event)">
                  </mat-checkbox>
                </th> -->
                    <th *ngFor="let item of taskColumnHeaderInfo" class="fs-14 font_bold cl-black">
                      <div class="p-5 verticle-center justify-content-space-between icon-style">
                        {{ item?.label }}
                        <span *ngIf="item.isMandatory" class="red-cl">&nbsp;* </span>
                        <div class="d-flex flex-column ml-10">
                          <i (click)="onSortAssending(item.sortingName)"
                            class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                          <i (click)="onSortDesending(item.sortingName)"
                            class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of tableDataDetails; let i = index">
                    <!-- <td>
                  <mat-checkbox [(ngModel)]="row.isSelected"></mat-checkbox>
                </td> -->
                    <td>
                      {{row.reimbursementType}}
                    </td>
                    <td>
                      {{ row.date | date: 'dd-MM-yyyy' }}
                    </td>
                    <td>
                      {{ row.dateOfExpense | date: 'dd-MM-yyyy' }}
                    </td>
                    <td>
                      {{row.reimbursementLimit}}
                    </td>
                    <td>
                      {{row.actualAmount}}
                    </td>
                    <td>
                      {{row.assignedAmount}}
                    </td>
                    <td>
                      <div *ngIf="row.uploadDocument !=  null">

                        <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/yellowdownload.png"
                          (click)="viewDocument(row.uploadDocument)" matTooltip="{{row.uploadDocument}}">
                      </div>
                    </td>
                    <td>
                      {{ formatedataVariable(row.status) }}
                    </td>
                    <td>
                      <!-- {{row.employeeComment}} -->
                      <textarea  rows="2" cols="4" class="edittextarea"
                        (ngModelChange)="managergetData(row)" [(ngModel)]="row.employeeComment" maxlength="255"
                        [ngModelOptions]="{standalone: true}" readonly ></textarea>
                    </td>
                    <td *ngIf="approveMatrixValueForCondition !='EMPLOYEE_TO_FINANCE'">
                      <!-- {{row.managerComment}} -->
                        <textarea rows="2" cols="4" class="edittextarea" (ngModelChange)="managergetData(row)" [(ngModel)]="row.managerComment"
                          maxlength="255" [ngModelOptions]="{standalone: true}" readonly></textarea>
                    </td>
                    <td>
                      <!-- {{row.financeComment}} -->
                        <textarea rows="2" cols="4" class="edittextarea" (ngModelChange)="managergetData(row)" [(ngModel)]="row.financeComment"
                          maxlength="255" [ngModelOptions]="{standalone: true}" readonly></textarea>
                    </td>
                    <td>
                          <span>
                            {{
                            row.approveMatrixValueForCondition === 'EMPLOYEE_TO_FINANCE'
                            ? (row.approvedStatus === 'REJECTED'
                            ? row.approvedStatus
                            : row.approvedStatus)
                            : (row.approvedStatus === 'REJECTED'
                            ? 'REJECTED'
                            : row.approvedStatus === 'APPROVED'
                            ? 'APPROVED'
                            : row.approvedByManager == null
                            ? (row.approvedStatus === 'PENDING'
                            ? row.approvedStatus
                            : row.approvedByManager)
                            : row.approvedByManager)
                            }}
                          </span>
                    </td>
                    
                    <td *ngIf="(row.approvedByManager != 'APPROVED' && row.approvedByManager != 'REJECTED') && (row.approvedStatus != 'APPROVED' && row.approvedStatus != 'REJECTED')">

                      <!-- (click)="deletePmsUnlockStatus(item.id)" -->
                      <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png"
                        (click)="addKPISPopup(row)">
                      <img class="cp imgdelete" (click)="deleteEmployee(row.reimbursementApplicationId)"
                        src="././assets/icon/delete.png">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mt-10" style="font-weight: bold;">
              {{tableDataDetails.length}} entries
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-------------------------------------------------------Manager Login ------------------------------------------------>

    <div class="card  employeeTab">

      <div class="p-10" *ngIf="selectedTypeTabName=='Manager'">
        <div style="width: 30%;">
          <ion-col size="4" class="mt-10">
            <div class="font_semibold fs-16 mb-5 ">
              Select Employee <span class="red-cl">&nbsp;*</span>
            </div>


            <!-- <ng-select class="w250 ml-10" dropdownPosition="bottom" [clearable]="false" placeholder="Select Employee">
              <ng-option [value]="item.employeeId" *ngFor="let item of allListingEmployeeIdForTeam">{{ item.employeeName }}</ng-option>
            </ng-select> -->
            <mat-form-field appearance="outline" class="w-100 mat-height40">
              <!--  [ngClass]="isReimbursementInvalid(item) ? 'red-background' : 'green-background'" -->
              <mat-select class="centered-label" name="reimbursementSelect"  [value]="-1" 
                (selectionChange)="getEmployeeForReimbursement($event.value)">
                <mat-option [value]="-1" >Select All Employee              
                </mat-option>
                <mat-option [value]="item.employeeId" *ngFor="let item of allListingEmployeeIdForTeam">

                  {{ item.employeeName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
        </div>

        <div class="table-container">

          <table class="custom-table rounded-header">

            <thead>
              <tr>
                <!-- <th class="mat-checkbox-style">
              <mat-checkbox
                [(ngModel)]="selectAllTaskCheckbox"
                [checked]="selectAllTaskCheckbox"
                (change)="selectALLTaskRecords($event)">
              </mat-checkbox>
            </th> -->
                <th *ngFor="let item of taskColumnHeaderInfoForManager " class="fs-14 font_bold cl-black">
                  <div class="p-5 verticle-center justify-content-space-between icon-style">
                    {{ item?.label }}
                    <span *ngIf="item.isMandatory"  class="red-cl">&nbsp;*</span>
                    <div class="d-flex flex-column ml-10">
                      <i (click)="onSortAssending(item.sortingName)"
                        class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                      <i (click)="onSortDesending(item.sortingName)"
                        class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of allTeamReimbursement; let rowId = index">
                <!-- <td>
              <mat-checkbox [(ngModel)]="row.isSelected"></mat-checkbox>
            </td> -->

                <td>
                  {{row.employeeName}}
                </td>
                <td>
                  {{row.reimbursementType}}
                </td>
                <td>
                  {{ row.date | date: 'dd-MM-yyyy' }}

                </td>
                  <td>
                    {{ row.dateOfExpense | date: 'dd-MM-yyyy' }}
                  </td>
                <td>
                  {{row.reimbursementLimit}}
                </td>
                <td>
                  {{row.actualAmount}}
                </td>
                <td>
                  {{row.assignedAmount}}
                </td>
                <td>
                  <!-- {{row.attachdocumentproof}} -->

                  <div *ngIf="row.uploadDocument !=  null">

                    <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/yellowdownload.png"
                      (click)="viewDocument(row.uploadDocument)" matTooltip="{{row.uploadDocument}}">
                  </div>
                </td>
                <td>
                  {{ formatedataVariable(row.status) }}
                </td>
                <td>
                  <!-- {{row.employeeComment}} -->
                  <textarea   rows="2" cols="4" class="edittextarea"
                     [(ngModel)]="row.employeeComment" maxlength="255"
                    [ngModelOptions]="{standalone: true}" readonly  ></textarea>
                </td>
                <td *ngIf="approveMatrixValueForCondition !='EMPLOYEE_TO_FINANCE'">
                  <textarea [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled" rows="2" cols="4"
                    class="edittextarea" (ngModelChange)="managergetData(row)" [(ngModel)]="row.managerComment"
                    maxlength="255" [ngModelOptions]="{standalone: true}"   [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled"></textarea>
                </td>
                <td>
                  <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.financeComment" maxlength="255"
                    [ngModelOptions]="{standalone: true}" readonly></textarea>

                  <!-- {{row.financeComment}} -->
                </td>
                <td>
                  <mat-form-field appearance="outline" class="w-100 mat-height40">
                   
                    <mat-select [(ngModel)]="row.approvedByManager" name="approvedByManager" class="centered-label"
                      (ngModelChange)="managergetData(row)" placeholder="PENDING"   [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled">
                      <!-- <mat-option value="PENDING">PENDING</mat-option> -->
                      <mat-option value="APPROVED">Approve</mat-option>
                      <mat-option value="REJECTED">Reject</mat-option>

                    </mat-select>
                  </mat-form-field>

                </td>
                <td *ngIf="row.managerStatus != 'APPROVED' && row.managerStatus != 'REJECTED'">
                  <!-- (click)="deletePmsUnlockStatus(item.id)" -->
                  <div class="d-flex">
                    <img (click)="onClickIndividualScoreEdit(rowId)" *ngIf="editedIndividualScoreId !== rowId"
                      class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">
                    <span (click)="getScoreToFinalConverterIndividual()"
                      *ngIf="editedIndividualScoreId === rowId && onCheckIconView"
                      class="material-icons close p-10 cp fs-20">close</span>
                    <span *ngIf="editedIndividualScoreId === rowId && onCheckIconView"
                      class="material-icons link p-10 cp fs-20" (click)="updateManager()">check</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>


        </div>
        <div class="mt-10" style="font-weight: bold;">
          {{allTeamReimbursement.length}} entries
        </div>
      </div>
    </div>
 
    <!-------------------------------------------------------Finance Login ------------------------------------------------>

    <div class="card  employeeTab">

      <div class="p-10" *ngIf="selectedTypeTabName=='Finance'">

        <ion-row>
          <ion-col size="4" class="mt-10" *ngIf="loggedInUserRole == 'HR Admin'">
            <div class="font_semibold fs-16 mb-5 ">
              Select Finance<span class="red-cl">&nbsp;*</span>
            </div>
            <mat-form-field appearance="outline" class="w-100 mat-height40">
              <mat-select
                class="centered-label"
                name="reimbursementSelect"
                [(ngModel)]="financeIdForEmployee"
                (selectionChange)="getFinaceForReimbursement($event.value)">
                <mat-option [value]="-1">Select All Finance</mat-option>
                <mat-option *ngFor="let item of fitergetAllFinanceUserDD" [value]="item.id">
                  {{ item.firstName }} {{ item.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
          </ion-col>
          <ion-col size="4" class="mt-10" *ngIf="isShowEmployee">
            <div class="font_semibold fs-16 mb-5 ">
              Select Employee<span class="red-cl">&nbsp;*</span>
            </div>

            <mat-form-field appearance="outline" class="w-100 mat-height40"> 
              <!--  [ngClass]="isReimbursementInvalid(item) ? 'red-background' : 'green-background'" -->
              <mat-select class="centered-label" name="reimbursementSelect"   [(ngModel)]="selectedEmployeeForFinance"
                (selectionChange)="getEmployeeForReimbursementApprove($event.value)">
                <mat-option [value]="-1" >Select All Employee              
                </mat-option>
                <mat-option [value]="item.employeeId" *ngFor="let item of allListingEmployeeId">

                  {{ item.employeeName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>




        
        </ion-row>




        <div class="table-container">

          <table class="custom-table rounded-header">

            <thead>
              <tr>
     
                <th *ngFor="let item of taskColumnHeaderInfoForFinanse" class="fs-14 font_bold cl-black">
                  <div class="p-5 verticle-center justify-content-space-between icon-style">
                    {{ item?.label }}
                    <span *ngIf="item.isMandatory"  class="red-cl">&nbsp;*</span>
                    <div class="d-flex flex-column ml-10">
                      <i (click)="onSortAssending(item.sortingName)"
                        class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                      <i (click)="onSortDesending(item.sortingName)"
                        class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of allTeamMemberReimbursementApprove; let rowId = index">
             
                <td>
                  {{row.employeeName}}
                </td>
                <td>
                  {{row.reimbursementType}}
                </td>
                <td>
                  {{ row.date | date: 'dd-MM-yyyy'}} 
                </td>
                  <td>
                    {{ row.dateOfExpense | date: 'dd-MM-yyyy' }}
                  </td>
                <td>
                  {{row.reimbursementLimit}}
                </td>
                <td>
                  {{row.actualAmount}}
                </td>
                <td>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">

                    <input [(ngModel)]="row.assignedAmount" type="number" (ngModelChange)="managergetData(row)"
                      [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled" matInput
                      placeholder="Set amount" class="font_regular" (keypress)="preventNegative($event)">
                  </mat-form-field>

                </td>
                <td>

                  <div *ngIf="row.uploadDocument !=  null">

                    <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/yellowdownload.png"
                      (click)="viewDocument(row.uploadDocument)" matTooltip="{{row.uploadDocument}}">
                  </div>
                </td>
                <td>
                  {{ formatedataVariable(row.status) }}
                </td>
                <td>
                  <textarea  rows="2" cols="4" class="edittextarea"
                                [(ngModel)]="row.employeeComment" maxlength="255" readonly [ngModelOptions]="{standalone: true}"></textarea>
                </td>
                <td *ngIf="approveMatrixValueForCondition !='EMPLOYEE_TO_FINANCE'">
                  <textarea  rows="2" cols="4" class="edittextarea"
                    [(ngModel)]="row.managerComment" maxlength="255" readonly [ngModelOptions]="{standalone: true}"></textarea>
                </td>
                <td>

              
                  <textarea [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled" rows="2" cols="4"
                    class="edittextarea" [(ngModel)]="row.financeComment" maxlength="255"
                    [ngModelOptions]="{standalone: true}"></textarea>
                </td>
                <td>
                  <mat-form-field appearance="outline" class="w-100 mat-height40">

                    <mat-select [(ngModel)]="row.approvedStatus" name="approvalStatus" class="centered-label"
                      (ngModelChange)="managergetData(row)" placeholder="PENDING"
                      [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled">
                      <!-- <mat-option value="PENDING">PENDING</mat-option> -->
                      <mat-option value="APPROVED">Approve</mat-option>
                      <mat-option value="REJECTED">Reject</mat-option>

                    </mat-select>
                  </mat-form-field> 

                </td>
                <td *ngIf="row.financeStatus != 'APPROVED' && row.financeStatus != 'REJECTED' ">
                  <!-- (click)="deletePmsUnlockStatus(item.id)" -->
                  <div class="d-flex">
                    <img (click)="onClickIndividualScoreEdit(rowId)"
                      *ngIf="editedIndividualScoreId !== rowId &&loggedInUserRole !== 'HR Admin'"
                      class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">
                    <span (click)="getScoreToFinalConverterIndividual()"
                      *ngIf="editedIndividualScoreId === rowId && onCheckIconView"
                      class="material-icons close p-10 cp fs-20">close</span>
                    <span *ngIf="editedIndividualScoreId === rowId && onCheckIconView" (click)="updateFinance()"
                      class="material-icons link p-10 cp fs-20">check</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-10" style="font-weight: bold;">
          {{allTeamMemberReimbursementApprove.length}} entries
        </div>
      </div>
    </div>
    
    <div class="card  employeeTab">
      
      <div class="p-10" *ngIf="selectedTypeTabName=='Reports'">
        <app-expense-report></app-expense-report>
      </div>
    </div>

      <div class="p-10" *ngIf="selectedTypeTabName=='Dashboard' && !router.url.includes('Setup')">
        <app-expense-dashboard></app-expense-dashboard>
      </div>
 
  </div>
</ion-content>